<div class="teaser-editor-back-button">
  <app-back-navigator class="app-back-navigator" [title]="'teaser.editor.back' | translate" (backClicked)="redirectToSensor()"> </app-back-navigator>
</div>

<div class="teaser-editor">
  <div class="teaser-editor-left">
    <div class="preview" *ngIf="selectedAsset?.src">
      <div class="uploader-title" [innerHtml]="'teaser.editor.uploaderTitle' | translate"></div>
      <div [ngSwitch]="isVideoType(selectedAsset)">
        <img alt="img" #img width="720" height="440" [attr.src]="selectedAsset.src" class="image" *ngSwitchCase="false" />
        <video controls width="720" height="440" *ngSwitchCase="true">
          <source [attr.src]="selectedAsset.src" type="video/mp4" />
        </video>
      </div>
    </div>
    <app-uploader
      [title]="'teaser.editor.uploaderTitle' | translate"
      [label1]="'teaser.editor.uploaderLabel1' | translate"
      [label2]="'teaser.editor.uploaderLabel2' | translate"
      [buttonLabel]="'teaser.editor.uploaderButtonLabel' | translate"
      (filesChanged)="onFilesChanged($event)"
      *ngIf="!selectedAsset?.src"
    >
    </app-uploader>
    <div class="thumbnails-row">
      <button title="prevButton" class="control prev" (click)="onPreviousClick()">
        <span class="arrow left"></span>
      </button>
      <app-thumbnails
        #thumbnails
        [titleText]="'teaser.editor.thumbnailsTitle' | translate"
        [indexText]="'teaser.editor.thumbnailsIndex' | translate"
        [addText]="'teaser.editor.thumbnailsAdd' | translate"
        [assets]="assets"
        [selectedAsset]="selectedAsset"
        [maxAssetCount]="maxAssetCount"
        (selectedAssetChange)="onThumbnailSelect($event)"
        (assetAdd)="onThumbnailAdd()"
        (assetDelete)="onThumbnailDelete($event)"
        class="app-thumbnails"
      >
      </app-thumbnails>
      <button title="nextButton" class="control next" (click)="onNextClick()">
        <span class="arrow right"></span>
      </button>
    </div>
    <app-notification-card class="app-notification-card" *ngIf="hasUnsupportedFile" type="error" [text]="'teaser.confirmationDialog.errorMessage' | translate">
    </app-notification-card>
  </div>

  <div class="teaser-editor-right">
    <div class="text-editors">
      <div class="title-content-area">
        <label class="header-content-label">{{ 'teaser.editor.headerContentLabel' | translate }}</label>
        <label class="header-content-details">{{ 'teaser.editor.headerContentDetails' | translate }}</label>
        <textarea title="headerText" matInput class="header-text-area" [(ngModel)]="titleContent" (ngModelChange)="onChanges()" ngDefaultControl></textarea>
      </div>
      <div class="description-content-area">
        <label class="description-content-label">{{ 'teaser.editor.contentDescriptionLabel' | translate }}</label>
        <label class="description-content-details">{{ 'teaser.editor.contentDescriptionDetails' | translate }}</label>
        <p-editor
          class="p-editor"
          [(ngModel)]="htmlContent"
          (onTextChange)="objChanged($event)"
          (ngModelChange)="onChanges()"
          (onInit)="saveEditorInstance($event)"
          ngDefaultControl
        >
          <p-header>
            <span class="ql-formats">
              <button class="ql-bold" aria-label="Bold"></button>
              <button class="ql-italic" aria-label="Italic"></button>
              <button class="ql-underline" aria-label="Underline"></button>
            </span>
            <span class="ql-formats">
              <button class="ql-list" aria-label="Numbered" value="ordered"></button>
              <button class="ql-list" aria-label="Bullet" value="bullet"></button>
              <button class="ql-link" aria-label="Link"></button>
            </span>
          </p-header>
        </p-editor>
        <label class="description-restrictions" [ngClass]="maxLengthReached || maxLinesReached ? '-error' : '-ok'">{{
          'teaser.editor.descriptionRestriction' | translate
        }}</label>
      </div>
      <div class="button-content-area">
        <label class="button-content-label">{{ 'teaser.editor.sendEmailBtnLabel' | translate }}</label>
        <input
          title="contentButton"
          type="text"
          maxlength="40"
          class="button-text-area"
          [(ngModel)]="btnTextContent"
          (ngModelChange)="onChanges()"
          ngDefaultControl
        />
        <label class="text-limit">{{ 'teaser.editor.sendEmailBtnTextLimit' | translate }}</label>
      </div>
      <div class="controls">
        <button class="btn btn-outline-primary btn-cancel" (click)="cancel()">{{ 'teaser.editor.cancel' | translate }}</button>
        <button class="btn btn-outline-primary btn-save" [disabled]="maxLengthReached || maxLinesReached" (click)="save()">
          {{ 'teaser.editor.save' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
